module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w98"
  }, [_c('div', {
    staticClass: "crumb"
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": "/Help"
    }
  }, [_vm._v("帮助")]), _vm._v("  > ")], 1), _vm._v(" "), _c('span', [_vm._v("音视频")])]), _vm._v(" "), _c('help-Menu'), _vm._v(" "), _c('div', {
    staticClass: "rightContent"
  }, [_c('div', {
    staticClass: "conten"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("在进行每日读片、专题读片及学习课程的过程中，可开启音视频互动。")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("中间为视频展示区域，点击【病案共享模式】/【视频会诊模式】可切换视频大小，病案共享模式可进行屏幕区域共享或文档共享。")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("左侧上方为参会人员展示区域，可看到当前加入会议的成员，并设置是否需要使用摄像头和麦克风。")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("左侧下方为公共聊天区域，主持人可在此与其他人互动。")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("点击【直播/录播】-【开始点播录制】生成一个直播地址及直播二维码，可通过手机扫一扫观看直播。")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("点击【直播/录播】-【停止直播】直播视频录制完成，生成一个录播地址及录播视频二维码，可通过手机扫一扫观看已经录制的直播视频。见下图。")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("视频客户端需提前下载，若没下载，点击教学右上角【视频客户端下载】即可。")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "89%"
    },
    attrs: {
      "src": require("../../../../static/image/89.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../../../static/image/90.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/image/91.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-193ad9b7","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/moudle/Audio/Audio.vue
// module id = 532
// module chunks = 1 2 3 4 5 6 7 8